// constants used for page names.
export const View = {
    CART: 'cart',
    PAYMENT_INFO: 'payment-info',
    PENDING_ORDER: 'pending-order'
};
